import helpers from "../utils/helpers";

const WooCheckout = {
  isSubbmiting: false,

  init() {
    WooCheckout.events();
  },

  events() {
    $("#order-form").on("submit", (e) => {
      e.preventDefault();
      const formEl = $(e.currentTarget);

      if (WooCheckout.isSubbmiting) {
        return;
      }
      WooCheckout.isSubbmiting = true;

      const valid = helpers.validate(formEl, false, true);
      if (!valid.length) {
        setTimeout(() => {
          WooCheckout.recaptcha();
        });
      } else {
        WooCheckout.handleMessage(valid, "error");
        // remove loader
        WooCheckout.isSubbmiting = false;
      }
    });

    $(".order-form__btn-person").on("click", (e) => {
      const btnEl = $(e.currentTarget);

      btnEl.addClass("active").siblings().removeClass("active");

      const legalColEls = $(".person-type-legal");
      const privateColEls = $(".person-type-private");

      if ("legal" == btnEl.data("type")) {
        legalColEls.removeClass("hidden");
        legalColEls.find("input").removeClass("disabled");

        privateColEls.addClass("hidden");
        privateColEls.find("input").addClass("disabled");

        if ($('.grid').hasClass("grid--company")) {
          return;
        } else {
          $('.grid').removeClass("grid--private");
          $('.grid').addClass("grid--company");
        }
      } else {
        legalColEls.addClass("hidden");
        legalColEls.find("input").addClass("disabled");

        privateColEls.removeClass("hidden");
        privateColEls.find("input").removeClass("disabled");

        if ($('.grid').hasClass("grid--private")) {
          return;
        } else {
          $('.grid').removeClass("grid--company");
          $('.grid').addClass("grid--private");
        }
      }
    });
  },

  handleMessage(messages, type) {
    const formMessageEl = $("#order-form").find(".form-message");

    formMessageEl.addClass(type).removeClass("hidden");

    let output = "";
    for (let i = messages.length - 1; i >= 0; i--) {
      output += messages[i] + "<br />";
    }

    formMessageEl.html(output);
  },

  /**
   * Recaptcha.
   */
  recaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        WooCheckout.send(token);
      });
    });
  },

  /**
   * Send form data to server.
   */
  send(token) {
    const formEl = $("#order-form");
    const formMessageEl = formEl.find(".form-message");
    const formData = new FormData(formEl[0]);

    formMessageEl.addClass("hidden");

    const userType = $(".order-form__btn-person.active").data("type");

    formData.append("token", token);
    formData.append("user-type", userType);

    console.log(formData);

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((resp) => {
        if (resp.success) {
          window.location.href = resp.data.redirect;
        } else {
          WooCheckout.handleMessage([resp.data.message], "error");
        }
      })
      .always(() => {
        WooCheckout.isSubbmiting = false;
      });
  },
};

export default WooCheckout;
